import get from 'lodash/get';
import * as constants from './constants';
import defaultState from '../state';

const featuredAdInitialState = get(defaultState, 'featuredAd');

export default (state = featuredAdInitialState, { type, payload }) => {
  switch (type) {
    case constants.RESET_FEATURED_AD: {
      return {
        ...state,
        ...{
          data: null,
          isExpired: false,
          error: null,
        },
      };
    }

    case constants.FETCH_FEATURED_AD_START: {
      return {
        ...state,
        ...{
          data: null,
          isExpired: false,
          error: null,
        },
      };
    }

    case constants.FETCH_FEATURED_AD_SUCCESS: {
      // shows only on the first time
      // then should not be shown anymore
      if (state.alreadyShownOnce) {
        return state;
      }
      return {
        ...state,
        ...{
          data: payload.featuredAd,
          isExpired: false,
          alreadyShownOnce: true,
          error: null,
        },
      };
    }

    case constants.FETCH_FEATURED_AD_FAILED: {
      return {
        ...state,
        ...{
          data: null,
          isExpired: true,
          alreadyShownOnce: true,
          error: payload.error,
        },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/FeaturedAd/reducer.js